module.exports = __webpack_public_path__ + "media/images/pc/articles/concept_title_deco-264fbe4a3c4198967b3fe467bafff48a.svg";